
<div  class="val-vue-facture-achat-recherche val-flex-conteneur val-flex-colonne">
  <div  class="val-vue-facture-achat-recherche-commandes">
    <val-barre-menus  [menuItems]="menuItems"></val-barre-menus>
  </div>
  <val-grille-recherche #grilleRecherche
    class="val-flex-1"
    identifiantRecherche="75D2D887-F527-4959-8C10-B9E518E4B44A"
    domaine="eFact"
    (selectionChange)="SelectionChange()"
    (doubleClick)="ExecuterActionsSurDoubleClick()"
    (colonneBoutonIconeClick)="OuvrirFicheBackOffice($event)">
  </val-grille-recherche>
</div>
<val-boite-dialogue-generique #boiteDialogue
  class="val-boite-dialogue-rapport-importation"
  [validerVisible]="false"
  [titre]="titreRapport | transloco"
  (annulerClick)="FermerRapportImportation()">
  <div contenu
    class="val-boite-dialogue-rapport-importation-contenu">
    <val-simple-panel>
      <div style="white-space: pre-wrap;">
        @for (ligne of lignesRapportImportation; track ligne) 
        {
          <div>{{ligne}}</div>
        }
      </div>
    </val-simple-panel>
  </div>
</val-boite-dialogue-generique>
<val-rechercher-complement-comptable-bt30 #rechercherComplementComptableBt30></val-rechercher-complement-comptable-bt30>
<val-facture-achat-fiche #factureAchatFiche></val-facture-achat-fiche>
<val-boite-dialogue-messages #boiteDialogueMessages></val-boite-dialogue-messages>
<val-boite-dialogue-generique #editionReferenceCommande
                              class="val-edition-reference-commande"
                              [titre]="'achat.recherche.reference-commande.titre' | transloco"
                              [validerDesactive]="referenceCommande === donneesEditionReferenceCommande.referenceCommande"
                              (validerClick)="ValiderEditionReferenceCommande()"
                              (annulerClick)="AnnulerEditionReferenceCommande()">
  <div contenu class="val-edition-reference-commande-contenu">
    <val-simple-panel>
      <val-controle-conteneur [label]="'achat.recherche.reference-commande.libelle' | transloco"
                              [tailleLabel]="120">
        <kendo-textbox class="val-kd-texte-editeur"
                       [(ngModel)]="donneesEditionReferenceCommande.referenceCommande">
        </kendo-textbox>
      </val-controle-conteneur>
    </val-simple-panel>
  </div>
</val-boite-dialogue-generique>
<val-mettre-a-jour-statut-factures-achat #mettreAJourStatutFacturesAchat></val-mettre-a-jour-statut-factures-achat>
<val-synchroniser-cycles-vies-factures-achat #synchroniserCyclesViesFacturesAchat></val-synchroniser-cycles-vies-factures-achat>
<val-rapprocher-commande-factures-achat #rapprocherCommandeFacturesAchat></val-rapprocher-commande-factures-achat>
<val-logs-transfert-factures-achat #logsTransfertFacturesAchat></val-logs-transfert-factures-achat>
<val-activer-desactiver-factures-achat #activerDesactiverFacturesAchat></val-activer-desactiver-factures-achat>
<val-refuser-factures-achat #refuserFacturesAchat></val-refuser-factures-achat>
<val-statuts-a-envoyer-factures-achat #statutsAEnvoyerFacturesAchat></val-statuts-a-envoyer-factures-achat>
<val-corbeille-ged-factures-achat #corbeilleGedFacturesAchat></val-corbeille-ged-factures-achat>